var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppTypeDigital(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.996,
    height: 23.997
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17532",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12958",
    d: "M18.999 12V7.827a2 2 0 00-.586-1.414l-2.829-2.827A2 2 0 0014.17 3H6.999a2 2 0 00-2 2v14a2 2 0 002 2h4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12959",
    d: "M7.999 8.999h8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12960",
    d: "M7.999 11.999h8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12961",
    d: "M7.999 14.998h2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12970",
    d: "M17.435 22.875a3.939 3.939 0 01-3.938-3.939 4 4 0 013.942-3.938 3.939 3.939 0 010 7.877"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12971",
    d: "M17.874 17.187L16.561 18.5l1.75.875-1.312 1.312",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12964",
    d: "M0 0h24v24H0z",
    fill: "none"
  })));
}
export default SvgAppTypeDigital;


//////////////////
// WEBPACK FOOTER
// ./src/icons/appTypeDigital.svg
// module id = 723
// module chunks = 11